/**
 * 更新任务内容请求
 */
export interface ApiUpdateTaskContentRequest<ContentType = string> {
    /**
     * 任务ID
     */
    taskId: string;
    /**
     * 任务内容类型
     */
    contentType: ContentType;
    /**
     * 任务内容
     */
    content: string;
}

/**
 * 更新任务内容
 */
export interface UpdateTaskContentApi<ContentType = string> {
    updateTaskContent(data: ApiUpdateTaskContentRequest<ContentType>): Promise<void>;
}

export const UpdateTaskContentApi = Symbol('UpdateTaskContentApi');

